import { GlButton, GlAnimatedChevronLgDownUpIcon, GlCollapse } from '@gitlab/ui';
import { __ } from '~/locale';
import AgentStatusIcon from './agent_status_icon.vue';
import AgentSessionRow from './agent_session_row.vue';
export default {
    name: 'AgentSessionsGroup',
    components: {
        GlButton,
        GlAnimatedChevronLgDownUpIcon,
        GlCollapse,
        AgentStatusIcon,
        AgentSessionRow
    },
    props: {
        group: {
            type: Object,
            required: true
        },
        headerBgClass: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            collapsed: false
        };
    },
    computed: {
        toggleLabel () {
            return this.collapsed ? __('Expand') : __('Collapse');
        }
    }
};
